import { Card } from "antd";
import { SurveyTemplate } from "../../../../../features/organization/survey/survey.type";

interface DetailsTemplateTitleProps {
  SurveyData: SurveyTemplate;
}

export default function DetailsTemplateTitle({
  SurveyData,
}: DetailsTemplateTitleProps) {
  return (
    <>
      <Card className="mt-4">
        <div className="self-stretch h-9 justify-start text-neutral-800 text-3xl font-medium">
          {SurveyData?.title}
        </div>

        <div className="self-stretch justify-start mt-3">
           {/* font-['Roboto'] */}
          <span className="text-zinc-700 text-base font-normal leading-normal">
            {SurveyData?.description}
          </span>
        </div>
      </Card>
    </>
  );
}
